// extracted by mini-css-extract-plugin
export var closeButton = "_g5-2";
export var closeButtonIcon = "_g5-3";
export var lightboxContent = "_g5-1";
export var lightboxOverlay = "_g5-0";